import { useCallback, useState } from 'react';

// const [open, openModal, closeModal] = useModal();

export const useModal = (initialValue = false) => {
  const [isOpen, setIsOpen] = useState(initialValue);

  const openModal = () => setIsOpen(true);

  const closeModal = () => setIsOpen(false);

  const toggleModal = useCallback(
    () => setIsOpen((prevState) => !prevState),
    []
  );

  return [isOpen, openModal, closeModal, toggleModal];
};
